export const loaderTheme = {
  backgroundColor: "#444",
  foregroundColor: "#999",
  backgroundOpacity: 0.5,
  foregroundOpacity: 0.5,
};
